const getProductoPremium = (productoPremiumId) => {
    return productoPremiumId ? productoPremiumId.split(',').includes('2') : false;
}

export default getProductoPremium